import type {
  AppLocale,
  ClientConfig,
  QueryCountryCode,
  SharedStaticConfig,
} from '@ngb-frontend/shared/types'

export const DEFAULT_COUNTRY: QueryCountryCode = 'GLOBAL'
export const DEFAULT_LOCALE: AppLocale = 'en-GLOBAL'

export const sharedStaticConfig: SharedStaticConfig = {
  apiRoutes: {
    content: '/api/content',
    driver: '/api/driver',
    booking: '/api/booking',
    countrySettings: '/api/countrySettings',
    createBooking: '/api/booking?action=create',
    updateBooking: '/api/booking?action=update',
    fetchBooking: '/api/booking?action=fetch',
    fetchBookingHistory: '/api/booking?action=fetchHistory',
    leaseChanges: '/api/contract/leaseChanges',
    supplierSearch: '/api/supplierSearch',
    vehicle: '/api/vehicle',
    serviceHistory: '/api/serviceHistory',
  },
  endpoints: {
    countrySettings: 'fe-settings',
    azurePublicKeys: 'https://login.microsoftonline.com',
    booking: 'booking',
    driver: 'driver',
    contract: 'contracts',
    supplierSearch: 'supplier-search',
    vehicleObject: 'vehicle-objects',
    serviceHistory: 'service_history/views/service_history',
    vehicleList: 'vehicle/views/vehicle-list',
    vehicleDetails: 'vehicle/views/vehicle-details',
  },
}

const datadogRumTracingUrls = [
  /http:\/\/localhost.+\/api\/.+/,
  /https:\/\/ngb-frontend.+\/api\/.+/,
  /https:\/\/eu-.+-api\.leaseplan\.com.+/,
  /https:\/\/ngbooking.leaseplan.com\/api\/.+/,
  /https:\/\/servicebooking\..+.com\/api\/.+/,
]

type PartialPick<T, TK extends keyof T> = { [P in TK]: Partial<T[P]> }

type PartialClientConfig = PartialPick<
  ClientConfig,
  'datadogLogConfig' | 'datadogRumConfig' | 'hotjarConfig'
>

export const staticClientConfig: PartialClientConfig = {
  datadogLogConfig: {
    forwardErrorsToLogs: true,
  },
  datadogRumConfig: {
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask',
    allowedTracingUrls: datadogRumTracingUrls,
  },
  hotjarConfig: {
    version: 6,
  },
}
